import { ProductFlow } from 'data/__generated__';

export const PRODUCT_FLOW_LABELS: Record<ProductFlow, string> = {
    [ProductFlow.Dry]: 'Sec',
    [ProductFlow.Fresh]: 'Frais',
    [ProductFlow.Fruit]: 'Fruits',
    [ProductFlow.Bakery]: 'Boulangerie',
    [ProductFlow.Caterer]: 'Traiteur',
    [ProductFlow.Kumo]: 'Kumo',
};

export enum Flow {
    BAKERY = 'bakery',
    DRY = 'dry',
    FRESH = 'fresh',
    KUMO = 'kumo',
    CATERER = 'caterer',
    FRUIT = 'fruit',
}

export const FLOWS: string[] = [Flow.DRY, Flow.FRESH, Flow.KUMO, Flow.CATERER, Flow.FRUIT, Flow.BAKERY];

export const FCC_CATERER_SUPPLIER_ID = '8ea33f3d-a407-4f28-a6a6-2d886bbaa511';
